import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { v4 as uuidv4 } from 'uuid';

@Injectable()
export class LoggerHelperService {

    private isBrowser: boolean;
    private _correlationId: string;

    constructor(
        @Inject(PLATFORM_ID) private platformId: any
    ) {
        this.isBrowser = isPlatformBrowser(platformId);
        this.setCorrelationId();
        if (!this.sessionId) {
            this.setSessionId();
        }
    }

    public get correlationId() {
        return this._correlationId;
    }
    public setCorrelationId() {
        this._correlationId = uuidv4();
    }

    public get sessionId(): string {
        if (this.isBrowser) {
            return sessionStorage.getItem('SessionId');
        }
        return null;
    }
    private setSessionId() {
        if (this.isBrowser) {
            sessionStorage.setItem('SessionId', uuidv4());
        }
    }

}